import script from "./ReservacionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservacionPage.vue?vue&type=script&setup=true&lang=js"

import "./ReservacionPage.vue?vue&type=style&index=0&id=c72ab2f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c72ab2f2"]])

export default __exports__